<script>
  import MarketingFlowChartArea from "./MarketingFlowChartArea.svelte";
  import {
    calc_total_for_surces_and_campaigns_data_table_dict,
    calculate_lead_flow_numbers,
    create_matrix,
    find_help_text_if_exists,
    get_dict_of_sources_and_campains,
    to_percentage,
  } from "./Utils.svelte";
  import SourceCatSelect from "./SourceCatSelect.svelte";
  import { is_country_checked } from "./UtilsBalkenProgress.svelte";

  export let crm_lead_all;
  export let lost_leads;
  export let lost_opportunities;
  export let archived;

  export let helptexts;
  export let in_show_helptext_id;

  export let selected_timeframe_text;

  export let laender_dict;

  let list_of_countries = [
    "Austria",
    "Netherlands",
    "United Kingdom",
    "Australia",
    "United States",
    "Germany",
    "Denmark",
    "Ireland",
    "New Zealand",
    "Switzerland",
  ];

  let list_of_countries_shorts = ["AT", "NL", "UK", "AU", "US", "DE", "DK", "IE", "NZ", "CH"];

  export let source_cat_dict;

  // let source_cat_dict = [
  //   { long: 'Advertising', short: 'Advertising (ADV)', checked: true },
  //   { long: 'Events', short: 'Events (EVT)', checked: true },
  //   { long: 'Organic', short: 'Organic (ORG)', checked: true },
  //   { long: 'Sales', short: 'Sales (SAL)', checked: true },
  // ];

  let source_cate_index_dict = {
    Advertising: 0,
    Events: 1,
    Organic: 2,
    Sales: 3,
  };

  let radio_buttons_split = 2;

  // let marketing_start_date = new Date(2022, 6, 1);
  // let marketing_end_date = new Date(2022, 7, 1);

  export let marketing_start_date = new Date(2022, 6, 1);
  export let marketing_end_date = new Date(2022, 7, 1);

  export let lost_leads_filtered;
  export let crm_lead_all_filtered;
  export let lost_opportunities_filtered;
  export let archived_filtered;

  let include_dataimport = false;

  export let flow_numbers_dict = false;

  let sources_and_campains_data_table_dict = false;
  let sources_and_campains_data_table_dict_finished = false;

  let sources_and_campains_data_table_dict_countries = {};

  let first_count = 2;

  $: {
    laender_dict, source_cat_dict, radio_buttons_split, marketing_start_date, marketing_end_date;

    if (first_count) {
      first_count -= 1;
    } else {
      if (laender_dict && source_cat_dict && radio_buttons_split && marketing_start_date && marketing_end_date) {
        all_lead_flow(lost_leads, crm_lead_all, archived, lost_opportunities);
      }
    }
  }

  function filter_all_leads_and_opportunities() {
    lost_leads_filtered = [];
    crm_lead_all_filtered = [];
    lost_opportunities_filtered = [];
    archived_filtered = [];

    lost_leads.forEach((element) => {
      if (element["source_category"] != "Sales" || true) {
        if (!is_country_checked(laender_dict, element["country"])) {
          return;
        }

        if (!element["source_category"]) {
          return;
        }

        if (source_cat_dict[source_cate_index_dict[element["source_category"]]]["checked"] == false) {
          return;
        }

        var create_date = new Date(element["x_date_creation"]);
        if (create_date >= marketing_start_date && create_date <= marketing_end_date) {
          lost_leads_filtered.push(element);
        }
      }
    });

    crm_lead_all.forEach((element) => {
      if (element[1]["source_category"] != "Sales" || true) {
        if (!is_country_checked(laender_dict, element[1]["country"])) {
          return;
        }

        if (!element[1]["source_category"]) {
          return;
        }

        if (source_cat_dict[source_cate_index_dict[element[1]["source_category"]]]["checked"] == false) {
          return;
        }

        var create_date = new Date(element[1]["create_date"]);
        if (create_date >= marketing_start_date && create_date <= marketing_end_date) {
          crm_lead_all_filtered.push(element[1]);
        }
      }
    });

    lost_opportunities.forEach((element) => {
      if (element["source_category"] != "Sales" || true) {
        if (!is_country_checked(laender_dict, element["country"])) {
          return;
        }

        if (!element["source_category"]) {
          return;
        }

        if (source_cat_dict[source_cate_index_dict[element["source_category"]]]["checked"] == false) {
          return;
        }

        var create_date = new Date(element["x_date_creation"]);
        if (create_date >= marketing_start_date && create_date <= marketing_end_date) {
          lost_opportunities_filtered.push(element);
        }
      }
    });

    archived.forEach((element) => {
      if (element[1]["source_category"] != "Sales" || true) {
        if (!is_country_checked(laender_dict, element[1]["x_country_id"][1])) {
          return;
        }

        if (source_cat_dict[source_cate_index_dict[element[1]["source_category"]]]["checked"] == false) {
          return;
        }

        var create_date = new Date(element[1]["x_date_creation"]);
        if (create_date >= marketing_start_date && create_date <= marketing_end_date) {
          archived_filtered.push(element[1]);
        }
      }
    });

    // console.log('country_list_tmp: ', country_list_tmp);
  }

  function funktionen_zusammenfassen(sources_and_campains_data_table_dict) {
    //Zuerst Die Werte pro Campaign berechnen
    for (const [source_category, sc_value] of Object.entries(sources_and_campains_data_table_dict)) {
      for (const [source, source_value] of Object.entries(sc_value)) {
        for (const [campaign, leads_per_campaign_list_dict] of Object.entries(source_value)) {
          sources_and_campains_data_table_dict[source_category][source][campaign]["results"] = calculate_lead_flow_numbers(
            "crm_lead_all_filtered" in leads_per_campaign_list_dict ? leads_per_campaign_list_dict["crm_lead_all_filtered"] : [],
            "lost_leads_filtered" in leads_per_campaign_list_dict ? leads_per_campaign_list_dict["lost_leads_filtered"] : [],
            "lost_opportunities_filtered" in leads_per_campaign_list_dict
              ? leads_per_campaign_list_dict["lost_opportunities_filtered"]
              : [],
            "archived_filtered" in leads_per_campaign_list_dict ? leads_per_campaign_list_dict["archived_filtered"] : [],
            marketing_start_date,
            marketing_end_date,
          );
        }
      }
    }

    //Dann die Werde per Source Summieren und in neuem Feld "Total" abspeichern
    for (const [source_category, sc_value] of Object.entries(sources_and_campains_data_table_dict)) {
      for (const [source, source_value] of Object.entries(sc_value)) {
        sources_and_campains_data_table_dict[source_category][source]["Total"] =
          calc_total_for_surces_and_campaigns_data_table_dict(source_value);
      }
    }

    // console.log("sources_and_campains_data_table_dict with total: ", sources_and_campains_data_table_dict)

    //Dann Matrix berechnen
    for (const [source_category, sc_value] of Object.entries(sources_and_campains_data_table_dict)) {
      for (const [source, source_value] of Object.entries(sc_value)) {
        for (const [campaign] of Object.entries(source_value)) {
          if (campaign != "Total") {
            sources_and_campains_data_table_dict[source_category][source][campaign]["matrix"] = create_matrix(
              source_category,
              source,
              campaign,
              sources_and_campains_data_table_dict[source_category][source][campaign]["results"],
              sources_and_campains_data_table_dict[source_category][source]["Total"],
            );
          } else {
            sources_and_campains_data_table_dict[source_category][source][campaign]["matrix"] = create_matrix(
              source_category,
              source,
              campaign,
              sources_and_campains_data_table_dict[source_category][source]["Total"],
              sources_and_campains_data_table_dict[source_category][source]["Total"],
            );
          }
        }
      }
    }

    // console.log('sources_and_campains_data_table_dict angereichert: ', sources_and_campains_data_table_dict);

    return sources_and_campains_data_table_dict;
  }

  function sum_two_dicts(x, y) {
    let ret_dict = {};

    var keys_1 = Object.keys(x);
    var keys_2 = Object.keys(y);

    keys_1 = keys_1.concat(keys_2);

    var keys = keys_1.filter(function (item, pos) {
      return keys_1.indexOf(item) == pos;
    });

    var i = 0;
    for (i = 0; i < keys.length; i = i + 1) {
      var k = keys[i];
      var a = k in x ? x[k] : 0;
      var b = k in y ? y[k] : 0;
      ret_dict[k] = a + b;
    }

    return ret_dict;
  }

  function add_sc_sums(extra_sums, begin_values) {
    let res_dict = {};

    let new_leads_all_sum = 0;
    let new_cust_all_sum = 0;

    for (const [source_category, sc_value] of Object.entries(begin_values).sort()) {
      res_dict[source_category] = {};
      let has_source = false;
      for (const [, source_value] of Object.entries(sc_value).sort()) {
        has_source = true;

        res_dict[source_category] = sum_two_dicts(res_dict[source_category], source_value["Total"]);
      }
      if (has_source) {
        var x = res_dict[source_category];
        extra_sums[source_category] = [
          extra_sums[source_category][0],
          "%%%",
          x["New_LEADS"],
          x["New_OPP"],
          x["Open_Leads"],
          x["Archived_Leads"],
          x["Lost_Leads"],
          x["New_CUST"],
          x["Open"],
          x["Archived"],
          x["Lost"],
          x["ADV_New_Boli"] + x["EVT_New_Boli"] + x["ORG_New_Boli"] + x["SAL_New_Boli"],
          "%%%",
        ];
        new_leads_all_sum += x["New_LEADS"];
        new_cust_all_sum += x["New_CUST"];
      }
    }

    for (const [source_category] of Object.entries(begin_values).sort()) {
      var x = res_dict[source_category];

      extra_sums[source_category][1] = to_percentage(x["New_LEADS"], new_leads_all_sum);
      extra_sums[source_category][12] = to_percentage(x["New_CUST"], new_cust_all_sum);
    }

    var total_sum = sum_two_dicts(res_dict["Advertising"], res_dict["Events"]);
    total_sum = sum_two_dicts(total_sum, res_dict["Organic"]);
    total_sum = sum_two_dicts(total_sum, res_dict["Sales"]);

    extra_sums["Total"] = [
      "Total",
      "100%",
      total_sum["New_LEADS"],
      total_sum["New_OPP"],
      total_sum["Open_Leads"],
      total_sum["Archived_Leads"],
      total_sum["Lost_Leads"],
      total_sum["New_CUST"],
      total_sum["Open"],
      total_sum["Archived"],
      total_sum["Lost"],
      total_sum["ADV_New_Boli"] + total_sum["EVT_New_Boli"] + total_sum["ORG_New_Boli"] + total_sum["SAL_New_Boli"],
      "100%",
    ];

    //über alle begin values iterieren (SC, Source) und pro SC total aufsummieren

    return extra_sums;
  }

  function all_lead_flow(lost_leads, crm_lead_all, archived, lost_opportunities) {
    filter_all_leads_and_opportunities(lost_leads, crm_lead_all, archived, lost_opportunities);

    // console.log('lost_leads_filtered: ', lost_leads_filtered);
    // console.log('archived_filtered: ', archived_filtered);
    flow_numbers_dict = calculate_lead_flow_numbers(
      crm_lead_all_filtered,
      lost_leads_filtered,
      lost_opportunities_filtered,
      archived_filtered,
      marketing_start_date,
      marketing_end_date,
      true,
    );

    //campaigns für den gewählten zeitraum finden
    // console.log("before get_dict_of_sources_and_campains")
    sources_and_campains_data_table_dict = {};
    sources_and_campains_data_table_dict["begin_values"] = get_dict_of_sources_and_campains(
      crm_lead_all_filtered,
      lost_leads_filtered,
      lost_opportunities_filtered,
      archived_filtered,
    );

    sources_and_campains_data_table_dict["extra_sums"] = {
      Advertising: ["Total ADV (Advertising)", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      Events: ["Total EVT (Events)", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      Organic: ["Total ORG (Organic)", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      Sales: ["Total SAL (Sales)", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      Total: ["Total", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    };

    sources_and_campains_data_table_dict["begin_values"] = funktionen_zusammenfassen(sources_and_campains_data_table_dict["begin_values"]);

    // console.log("sources_and_campains_data_table_dict davor: ", sources_and_campains_data_table_dict)

    sources_and_campains_data_table_dict["extra_sums"] = add_sc_sums(
      sources_and_campains_data_table_dict["extra_sums"],
      sources_and_campains_data_table_dict["begin_values"],
    );

    // console.log("sources_and_campains_data_table_dict davor: ", sources_and_campains_data_table_dict)

    list_of_countries.forEach((country) => {
      sources_and_campains_data_table_dict_countries[country] = {};
      sources_and_campains_data_table_dict_countries[country]["begin_values"] = get_dict_of_sources_and_campains(
        crm_lead_all_filtered,
        lost_leads_filtered,
        lost_opportunities_filtered,
        archived_filtered,
        true,
        country,
      );
      sources_and_campains_data_table_dict_countries[country]["extra_sums"] = {
        Advertising: ["Total ADV (Advertising)", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        Events: ["Total EVT (Events)", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        Organic: ["Total ORG (Organic)", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        Sales: ["Total SAL (Sales)", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        Total: ["Total", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      };

      sources_and_campains_data_table_dict_countries[country]["begin_values"] = funktionen_zusammenfassen(
        sources_and_campains_data_table_dict_countries[country]["begin_values"],
      );

      sources_and_campains_data_table_dict_countries[country]["extra_sums"] = add_sc_sums(
        sources_and_campains_data_table_dict_countries[country]["extra_sums"],
        sources_and_campains_data_table_dict_countries[country]["begin_values"],
      );
    });

    sources_and_campains_data_table_dict_finished = true;

    //leads nach campaign und source filtern und in dict abspeichern
    // für jede campaign calculate_lead_flow_numbers aufrufen und in großes dict speichern
    //=> das selbe für länder wiederholen
  }

  $: {
    lost_leads, crm_lead_all, lost_opportunities, archived;

    if (lost_leads && crm_lead_all && archived && lost_opportunities) {
      sources_and_campains_data_table_dict_finished = false;

      all_lead_flow(lost_leads, crm_lead_all, archived, lost_opportunities);
    }
  }
</script>

<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h5 class="card-title">Marketing conversion flow {selected_timeframe_text}</h5>
    <div class="info-circle my-auto">
      <div class="my-auto info-i">i</div>
      <div class="info-box" style="color: #000000;">
        {#if find_help_text_if_exists(helptexts, "marketing_mirror_conversion_flow")}
          {@html find_help_text_if_exists(helptexts, "marketing_mirror_conversion_flow")}
        {:else}
          <p>
            The <strong>marketing conversion flow</strong> is based on leads created during the reporting timeframe and shows how they evolved
            over time until today.
          </p>
          <p>Please note</p>
          <ul>
            <li>
              <strong>Selection of lead countries</strong>:<br />All information in the chart relates to the countries selected under
              &ldquo;Select lead countries&rdquo;. This means that only new leads in these countries form the basis of this report.
            </li>
            <li>
              <strong>Selection of source categories</strong>:<br />Only new leads of the selected source categories are shown in this
              chart.
            </li>
            <li>
              <strong>Handling of leads based on data imports</strong>: <br />Leads from the sales source category "data import" are only
              counted as &rdquo;new lead" if an opportunity is created based on the lead. In this case, the lead creation date is the same
              as the opportunity creation date.
            </li>
          </ul>
          <br /><br />
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: marketing_mirror_conversion_flow</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div>
  </div>
  <div class="card-body" style="z-index: 1; padding-top:0px;">
    <div class="row box-flow-top">
      <div class="col-4">
        <div class="row flex vertical-center">
          <div class="col-2" />
          <div class="col-10">
            <b class="form-check-label" style="margin-left:-40px; margin-bottom:20px;">Select source categories:</b>
            <SourceCatSelect bind:source_cat_dict />
          </div>
        </div>
      </div>

      <div class="col-4 trenner-links">
        <div class="row flex vertical-center">
          <div class="col-2" />
          <div class="col-10">
            <b class="form-check-label" style="margin-left:-20px; margin-bottom:20px;">Split data:</b>
            <div class="row">
              <label>
                <input style="font-size: 12px;" type="radio" bind:group={radio_buttons_split} name="radio_buttons_split" value={1} />
                no split
              </label>
            </div>

            <div class="row">
              <label>
                <input style="font-size: 12px;" type="radio" bind:group={radio_buttons_split} name="radio_buttons_split" value={2} />
                split into source categories
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div id="card_for_svg" class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xxl-12" style="padding-top:10px">
        {#if flow_numbers_dict && sources_and_campains_data_table_dict_finished}
          <MarketingFlowChartArea
            {flow_numbers_dict}
            {sources_and_campains_data_table_dict}
            {radio_buttons_split}
            {sources_and_campains_data_table_dict_countries}
            {list_of_countries}
            {list_of_countries_shorts}
          />
        {/if}
      </div>
    </div>
  </div>
</div>

<style>
  .box-flow-top {
    background-color: #fbfcfc;
    border-width: 0.25px;
    border-style: solid;
    border-color: #afc5b9;
    padding: 20px;
    margin: 20px;
  }

  .hiddenClass {
    visibility: hidden;
    display: none;
  }

  .trenner-links {
    border-left: 3px solid #d9d9d9;
  }

  .info-box-auf-hoehe {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: auto;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: inherit;
    left: 200px;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: 600;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: 50px;
    right: 50px;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box:hover .info-box {
    display: block;
  }

  .info-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: #eef3f0;*/
    border: 1px solid #999999;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    text-align: center;
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-circle:hover .info-i {
    display: none;
  }

  .hoverclass:hover .info-box {
    display: block;
  }

  .hoverclass:hover .info-i {
    display: none;
  }

  .info-box-auf-hoehe:hover .info-box-auf-hoehe {
    display: block;
  }

  .info-circle:hover .info-box-auf-hoehe {
    display: block;
  }

  .hoverclass:hover .info-box-auf-hoehe {
    display: block;
  }
</style>
